<div class="layout-bookmarks-form">
  <ebw-monorepo-sidebar-header [icon]="'bookmark'" [title]="title" [isSvg]="false" [isOutline]="true">
  </ebw-monorepo-sidebar-header>
  <form class="d-flex flex-column" [formGroup]="bookmarkForm">
    <div [hidden]="!flagPermessoVisibilityBookmark" class="visibility">
      <mat-slide-toggle formControlName="visibility">
        <span class="visibility-text pe-2">{{ 'map.sidebar.bookmark.set_public' | translate }}</span>
      </mat-slide-toggle>
      <mat-icon class="visibility-eye">{{
        bookmarkForm.get('visibility').value ? 'visibility' : 'visibility_off'
      }}</mat-icon>
    </div>
    <div class="form-row mb-3">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>{{ 'map.sidebar.bookmark.name_view' | translate }}</mat-label>
        <input matInput formControlName="name" required />
        <mat-error *ngIf="bookmarkForm.get('name').invalid">{{ 'common.required_field' | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div class="form-row mb-3">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>{{ 'map.sidebar.bookmark.description' | translate }}</mat-label>
        <textarea matInput formControlName="description"></textarea>
      </mat-form-field>
    </div>
    <div class="form-row mb-3">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>{{ 'map.sidebar.bookmark.central_point' | translate }}</mat-label>
        <input matInput formControlName="central_point" [readonly]="true" />
      </mat-form-field>
    </div>
    <div class="form-row mb-3">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>{{ 'map.sidebar.bookmark.projection' | translate }}</mat-label>
        <input matInput formControlName="projection" [readonly]="true" />
      </mat-form-field>
    </div>
    <div class="form-row mb-3">
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>{{ 'map.sidebar.bookmark.levels' | translate }}</mat-label>
        <textarea matInput formControlName="levels" [readonly]="true"></textarea>
        <button
          mat-button
          matSuffix
          aria-label="refresh"
          class="refresh-icon"
          (click)="refreshLayer()"
          [disabled]="id || id == 0"
        >
          <mat-icon>refresh</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="pt-2 pb-2">
      <mat-label>
        {{ 'map.sidebar.bookmark.data_modifica' | translate }}
        {{ bookmarkForm.get('date_modified').value | date : 'dd/MM/yy HH:mm:ss' }}
      </mat-label>
    </div>
    <div class="p-2">
      <button mat-flat-button color="primary" class="w-100" (click)="bookmarkHandler()">
        <span>{{ 'common.save' | translate }}</span>
      </button>
    </div>
    <div class="p-2">
      <button
        mat-flat-button
        color="accent"
        class="w-100"
        (click)="deleteView(id, bookmarkForm.get('name').value)"
        *ngIf="id"
      >
        <span>{{ 'common.remove' | translate }}</span>
      </button>
    </div>
  </form>
</div>
